module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"latest products":"Latest products"},"de":{"latest products":"Neueste Produkte"}}')
  delete Component.options._Ctor
}
